var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFooterInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.9814C11.5609 13.9814 12.5783 13.56 13.3284 12.8099C14.0786 12.0597 14.5 11.0423 14.5 9.98145C14.5 8.92058 14.0786 7.90316 13.3284 7.15302C12.5783 6.40287 11.5609 5.98145 10.5 5.98145C9.43913 5.98145 8.42172 6.40287 7.67157 7.15302C6.92143 7.90316 6.5 8.92058 6.5 9.98145C6.5 11.0423 6.92143 12.0597 7.67157 12.8099C8.42172 13.56 9.43913 13.9814 10.5 13.9814Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.9814V5.98145C1.5 4.65536 2.02678 3.38359 2.96447 2.44591C3.90215 1.50823 5.17392 0.981445 6.5 0.981445H14.5C15.8261 0.981445 17.0979 1.50823 18.0355 2.44591C18.9732 3.38359 19.5 4.65536 19.5 5.98145V13.9814C19.5 15.3075 18.9732 16.5793 18.0355 17.517C17.0979 18.4547 15.8261 18.9814 14.5 18.9814H6.5C5.17392 18.9814 3.90215 18.4547 2.96447 17.517C2.02678 16.5793 1.5 15.3075 1.5 13.9814Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.49147L16.01 4.48047",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooterInsta);
export default __webpack_public_path__ + "static/media/ic_footer_insta.1be608013936c2b6b1fff1580beaf37b.svg";
export { ForwardRef as ReactComponent };